import React from "react";
import { motion } from "framer-motion";
import { useApp } from "../context/AppContext";
import { Activity, LogOut } from "lucide-react";
import NotificationBell from "./NotificationBell";

const TABS = [
  { id: "overview", label: "Overview" },
  { id: "portfolio", label: "Portfolio" },
  { id: "recommendations", label: "Recommendations" },
  { id: "markets", label: "Markets & News" },
  { id: "indian", label: "Indian Screener" },
  { id: "global", label: "Global & Macro" },
  { id: "rebalancer", label: "Allocator" },
  { id: "retirement", label: "Retirement & Goals" },
  { id: "triggers", label: "Triggers" },
  { id: "ai", label: "AI Room" },
];

export default function Navbar({ active, setActive }) {
  const { user, logout, currency, setCurrency, macro } = useApp();

  return (
    <header data-noprint className="sticky top-0 z-40 border-b border-[#1e293b]"
      style={{ background: "rgba(15,20,32,0.85)", backdropFilter: "blur(12px)" }}>
      <div className="max-w-[1500px] mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-14 relative">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center"
              style={{ background: "rgba(0,229,255,0.12)", border: "1px solid rgba(0,229,255,0.4)" }}>
              <Activity className="w-4 h-4 text-[#00e5ff]" />
            </div>
            <div className="leading-tight">
              <div className="font-semibold tracking-tight text-sm whitespace-nowrap">Alpha-Orchestrator</div>
              <div className="hidden sm:flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#00e676] live-dot" />
                <span className="font-mono text-[10px] text-[#64748b]">{macro?.regime || "LIVE"} · {macro?.india_gsec_10y}% G-Sec</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-2 absolute left-1/2 -translate-x-1/2">
            <span className="text-sm text-[#94a3b8]">Built by <span className="text-[#00e5ff] font-semibold">Abhishek Singh</span></span>
          </div>

          <div className="flex items-center gap-2">
            <NotificationBell setActive={setActive} />
            <div className="flex rounded-lg border border-[#2d3c59] overflow-hidden" data-testid="currency-toggle">
              {["INR", "USD"].map((c) => (
                <button key={c} data-testid={`currency-toggle-${c}`}
                  onClick={() => setCurrency(c)}
                  className={`px-2 sm:px-3 py-1.5 font-mono text-xs whitespace-nowrap transition-colors ${currency === c ? "bg-[#00e5ff] text-[#06121a]" : "text-[#94a3b8] hover:text-[#f8fafc]"}`}>
                  {c === "INR" ? "₹" : "$"}<span className="hidden sm:inline"> {c}</span>
                </button>
              ))}
            </div>
            <div className="hidden md:flex items-center gap-2 pl-2">
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-[#2d3c59]" />
              ) : (
                <div className="w-7 h-7 rounded-full bg-[#1a2338] border border-[#2d3c59] flex items-center justify-center font-mono text-xs text-[#00e5ff]">
                  {(user?.name || user?.email || "?")[0]?.toUpperCase()}
                </div>
              )}
              <span className="text-xs text-[#94a3b8] max-w-[120px] truncate">{user?.name || user?.email}</span>
            </div>
            <button data-testid="logout-btn" onClick={logout}
              className="w-8 h-8 rounded-lg border border-[#2d3c59] flex items-center justify-center text-[#94a3b8] hover:text-[#ff3b30] hover:border-[#ff3b30]/50 transition-colors">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>

        <nav className="flex gap-1 -mb-px overflow-x-auto scroll-x">
          {TABS.map((t) => (
            <button key={t.id} data-testid={`nav-tab-${t.id}`} onClick={() => setActive(t.id)}
              className={`relative px-3.5 py-2.5 text-sm whitespace-nowrap transition-colors ${active === t.id ? "text-[#f8fafc]" : "text-[#64748b] hover:text-[#94a3b8]"}`}>
              {t.label}
              {active === t.id && (
                <motion.div layoutId="tab-underline" className="absolute left-0 right-0 bottom-0 h-0.5 bg-[#00e5ff]" />
              )}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
